import Swiper, { Navigation } from 'swiper';

export default function initArchiveEvents() : void {
    const $archiveEventsPage = document.querySelectorAll<HTMLElement>('.events-archive');
    $archiveEventsPage.forEach($container => {
        new ArchiveEventsPage($container);
    });
}

// todo : slider pour rdv
class ArchiveEventsPage {
    $el: HTMLElement;
    $rdvEventsSlider: HTMLElement | null = null;
    mdBreakpoint: number;
    rdvEventsSwiper: Swiper | null = null;


    constructor($el: HTMLElement) {
        this.$el = $el;
        const $select = this.$el.querySelector<HTMLInputElement>('.js-archive-events-select');

        const $highlights = $el.querySelector('.events-archive-highlights');
        const $highlightsSlider = $highlights?.querySelector<HTMLElement>('.hightlights-slider');

        const $rdvEvents = $el.querySelector('.events-archive-rdv-event');
        const $rdvEventsSlider = $rdvEvents?.querySelector<HTMLElement>('.rdv-events-slider');

        if ($select) {
            this.initSelect($select);
        }
        
        if ($highlightsSlider) {
            this.createSwiper($highlightsSlider);
        }

        this.mdBreakpoint = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md'));

        if ($rdvEventsSlider) {
            this.$rdvEventsSlider = $rdvEventsSlider;
            window.addEventListener('resize', this.initRdvEventsSliderOnResize.bind(this));
            this.initRdvEventsSliderOnResize();
        }

    }

    /**
     * Événement lancé à chaque resize de la fenêtre
     * Détermine s'il faut créer ou détruire le swiper
     */
    initRdvEventsSliderOnResize(): void {
        if (this.rdvEventsSwiper && window.innerWidth > this.mdBreakpoint) {
            // Détruit le swiper s'il est déjà créé et qu'on est au dessus du breakpoint MD
            this.destroyRdvEventsSwiper();
        } else if (!this.rdvEventsSwiper && window.innerWidth <= this.mdBreakpoint) {
            // Créé le swiper s'il n'est pas déjà créé et q'uon est au dessous du breakpoint MD
            this.createRdvEventsSwiper();
        }
    }
        
    /**
     * Création du Swiper highlight
     * 
     * @param {HTMLElement} $highlightsSlider
     * 
     * @return {void}
     */
    createSwiper($highlightsSlider: HTMLElement): void {
        new Swiper($highlightsSlider, {
            modules: [Navigation],
            slidesPerView: 1,
            spaceBetween: 10,
            loop: false,
            allowTouchMove: true,
            grabCursor: true,
            navigation: {
                nextEl: '.slider-next',
                prevEl: '.slider-prev',
            },
        });
    }

    /**
     * Création du Swiper events
     * 
     * @return {void}
     */
    createRdvEventsSwiper(): void {
        if (!this.$rdvEventsSlider) {
            return
        }

        new Swiper(this.$rdvEventsSlider, {
            slidesPerView: 'auto',
            spaceBetween: 16,
            allowTouchMove: true,
            grabCursor: true,
        });
    }

    /**
     * Destruction du Swiper events
     * 
     * @return {void}
     */
    destroyRdvEventsSwiper(): void {
        if (this.rdvEventsSwiper) {
            this.rdvEventsSwiper.destroy(true, true);
            this.rdvEventsSwiper = null;
        }
    }

    /**
     * Initialise la redirection via la valeur du select select
     * 
     * @param {HTMLInputElement} $select
     *
     * @return {void}
     */
    initSelect($select: HTMLInputElement) {
        $select.addEventListener('change',() => {
            window.location.href = $select.value;
        });
    }
}
